export const GET_LANDING_PAGES = "GET_LANDING_PAGES";
export const GET_DEFAULT_WARN_CONFIGS = "GET_DEFAULT_WARN_CONFIGS";
export const GET_OPERATOR_WARN_CONFIGS = "GET_OPERATOR_WARN_CONFIGS";
export const GET_OPERATION_SUPPORT_GUIDANCE_TYPE = "GET_OPERATION_SUPPORT_GUIDANCE_TYPE";
export const GET_CHART_RELOAD_INTERVAL_TIME_TYPE = "GET_CHART_RELOAD_INTERVAL_TIME_TYPE";